import { BaseShare } from './baseShare';
import { DingdingShare } from './dingdingShare';
import { WxShare } from './wxShare';
import share from './share';

export { WxShare, BaseShare, DingdingShare, share };
export { getDefaultSessionTitle, getDefaultSessionDesc, getShareIcon } from './shareCommon';
